import { toast } from "react-toastify";
import config from "../config";
import { showErrorToast } from "../pages/utils";

export const createMarkerData = (properties) => {
    return properties?.map((item) => {
        let imageUrl = null;
        if (item.images && item.images.length > 0 && item.images[0].image_url) {
            const url = item.images[0].image_url.trim();
            imageUrl = url.includes("http") ? url : `${config.get("API_URL")}${url}`;
        }

        return {
            address: item.address,
            description: item.description,
            price: item.price,
            owner_info: item.owner_info,
            latitude: item.latitude,
            longitude: item.longitude,
            property_id: item.property_id,
            beds: item.beds,
            baths: item.baths,
            img: imageUrl,
        };
    });
};

export const formatUSAPrice = (amount) => {
    return amount?.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
};

export const validatePhoneNumber = (value) => {
    if (value.length < 10) {
        showErrorToast("The phone number must be 12 digits.", {
            autoClose: 3000,
            pauseOnHover: false,
        });
        return false;
    } else if (value.length > 12) {
        showErrorToast("The phone number must not exceed 12 digits.", {
            autoClose: 3000,
            pauseOnHover: false,
        });
        return false;
    } else {
        return true;
    }
};

const deg2rad = (deg) => deg * (Math.PI / 180);

export const isValidPhoneNumber = (phone) => {
    const cleaned = phone.replace(/\D/g, "");

    if (cleaned.length < 10) return false;

    const invalidPatterns = [
        /^0+$/,
        /^1+$/,
        /^1234567890$/,
        /^0123456789$/,
        /^9{10}$/,
        /^(\d)\1+$/, // repeated same digit
    ];

    return !invalidPatterns.some((pattern) => pattern.test(cleaned));
};
